<script>
import { CompetitionApplication } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import FiltersMixin from '@/views/CompetitionApplication/FiltersMixin'

export default {
  mixins: [ListMixin, FiltersMixin],
  data() {
    return {
      editRouteName: 'CompetitionApplication Detail',
      verboseName: 'Formularz zgłoszeniowy',
      verboseNamePlural: 'Formularze zgłoszeniowe',
      listFields: [
        { prop: 'short_id', label: 'id' },
        {
          prop: 'district',
          label: 'dzielnica',
          formatter: this.getDistrictLabel
        },
        {
          prop: 'name',
          label: 'imię i nazwisko'
        },
        {
          prop: 'email',
          label: 'email'
        },
        {
          prop: 'created',
          label: 'Data utworzenia',
          formatter: this.formatDate('created')
        }
      ],
      exportButtonDisabled: false
    }
  },
  computed: {
    service() {
      return CompetitionApplication
    }
  },
  methods: {
    exportApplications() {
      this.exportButtonDisabled = true
      let params = {
        ...this.filters.selected
      }
      this.service
        .export({}, { params })
        .then(response => {
          this.$message({
            message: 'Utworzono nowe zadanie: EXPORT.',
            type: 'success'
          })
          this.$router.push({ name: 'ExportFiles List' })
        })
        .catch(error => {
          this.exportButtonDisabled = false
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.showErrorsMessage(error.response)
            this.errors = this.parseErrorsDict(error.response.data)
            this.showErrorsOnTabsHeaders()
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request)
          }
        })
    },
    actions(scope) {
      return [
        {
          component: 'router-link',
          attrs: {
            to: this.getEditRoute(scope.row)
          },
          children: [
            this.getButtonComponent({ icon: 'fa fa-edit', title: 'Szczegóły' })
          ]
        },
        ...this.additionalActions(scope)
      ]
    },
    headerActions() {
      return [
        this.getButtonComponent({
          label: 'EXPORTUJ',
          onClick: this.exportApplications,
          disabled: this.exportButtonDisabled
        })
      ]
    }
  }
}
</script>
